module.exports = __webpack_public_path__ + "img/25_mustang.48a2402d.png";